// --------------------------------------------------------------------------
// Supporter Details Page Helper Module
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var GdprPreferences = require('./gdpr-preferences');

module.exports = function (options) {
    var ref = { $root: options.context },
        authContactLookup = ref.$root.data('auth-contact-lookup');
    ref.$form = ref.$root.find('form');
    ref.$submit = ref.$root.find('#Submit');
    ref.$underAgeInputs = ref.$root.find('[data-binding="contact-details-underage"]');

    // below input fields will be tracked for user interaction
    var checkInputsForValues = ['ContactDetails.FirstName', 'ContactDetails.LastName', 'ContactDetails.Title', 'Address.PostcodeLookup', 'ContactDetails.HomePhone', 'ContactDetails.SupporterEmailAddress', 'ContactDetails.MobilePhone'];

    function enableValidation() {
        ref.$submit.removeAttr('disabled');

        // bring back the validation
        ref.$form.validate().settings.ignore = ':hidden';
    }

    function init() {
        // elements with class="ignore" should be ignored by jQuery Validate
        if (false === authContactLookup) {
            ref.$form.validate().settings.ignore = '.ignore';
        } else {
            ref.$form.validate().settings.debug = true;
            // manually handle the submit when contact lookup has been used
            ref.$form.validate().settings.submitHandler = function (form) {
                // validate the GDPR data using its module
                var gdprPreferences = new GdprPreferences({ context: $('[data-behavior="gdpr-preferences"]') });
                // run the validation
                var valid = gdprPreferences.valid();

                // remove previously added validation-summary block
                $('.validation-summary').remove();

                if (!valid.result) {
                    // if the form is invalid, display errors
                    var validationErrors = '';
                    $.each(valid.errors, function (index, error) {
                        validationErrors += '<li>' + error.message + '</li>';
                    });
                    $('[data-name="gdpr-wrapper"]').prepend('<div class="validation-summary"><div class="validation-summary-errors">' + validationErrors + '</div></div>');
                } else {
                    // submit the form further if no errors within GDPR block,
                    // add the Submit POST data that would normally be sent
                    // if the "SUBMIT" button were clicked by a suer
                    $('<input type="hidden"/>').attr('name', 'Submit').appendTo($(form));
                    form.submit();
                }
            };
        }

        var allInputsEmpty = true;
        $.each(checkInputsForValues, function (index, el) {
            var $input = $('[name="' + el + '"]');

            if ($input.length) {
                $input.on('change', function () {
                    enableValidation();
                });

                if ($input.val().length > 0) {
                    allInputsEmpty = false;
                }
            }
        });

        if (false === allInputsEmpty) {
            enableValidation();
        }

        // add .ignore class to the Under age block
        ref.$underAgeInputs.addClass('ignore');
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/supporter-details-page.js
// module id = 498
// module chunks = 0